import { useAuth } from "@/context/auth";
import { MerchantUserType } from "@/models/club";
import useGetMerchant from "@/pages/dashboard/profile/hooks/useGetMerchant";
import { useGetMerchantForMerchantUser } from "@/services/merchant/utilities";
import { hasManagerAccess, stylistMenuPaths } from "@/utilities/dashboardAccess";

export default function useDashboardAccess() {
  const { getUserByToken } = useAuth();
  const phone = getUserByToken()?.phoneNumber ?? "";
  const merchant = useGetMerchant();
  const member = useGetMerchantForMerchantUser(phone);
  const role = member.data?.merchantUserType;
  const isOwner = Boolean(phone && merchant.data?.phoneNumber === phone);
  const isManager = hasManagerAccess(role, isOwner);
  const isStylist = !isManager && role === MerchantUserType.Value2;
  const isResolved = isManager || isStylist;

  return {
    isManager,
    isStylist,
    isResolved,
    isLoading: !isResolved && (merchant.isLoading || member.isLoading),
    retry: () => { void merchant.refetch(); void member.refetch(); },
    canViewMenu: (path: string) => isManager || (isStylist && stylistMenuPaths.some((item) => item === path)),
  };
}
